"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketProvider = void 0;
const react_1 = __importStar(require("react"));
const WebSocketContext_1 = require("./WebSocketContext");
const WebSocketProvider = ({ children, currentProfileGid, logError, webSocketUrl, }) => {
    const [webSocket, setWebSocket] = react_1.useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const channelsRef = react_1.useRef({});
    const sendMessage = react_1.useCallback((identifier, command, payload = {}) => {
        if (!webSocket)
            return;
        const message = JSON.stringify({
            command,
            data: JSON.stringify(payload),
            identifier: JSON.stringify(identifier),
        });
        webSocket.send(message);
    }, [webSocket]);
    const registerForChannel = react_1.useCallback((channel, identifiers, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    eventHandler) => {
        const identifier = Object.assign({ channel }, identifiers);
        sendMessage(identifier, 'subscribe');
        channelsRef.current[JSON.stringify(identifier)] = eventHandler;
    }, [sendMessage]);
    const sendCommand = react_1.useCallback((channel, identifiers, command, action = {}) => {
        // NOTE: The identifier in the backend is a stringified json object
        const identifier = Object.assign({ channel }, identifiers);
        sendMessage(identifier, command, action);
    }, [sendMessage]);
    react_1.useEffect(() => {
        if (webSocket || !currentProfileGid)
            return;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const newWebSocket = yield new Promise((resolve) => {
                const ws = new WebSocket(webSocketUrl);
                ws.onmessage = (event) => {
                    var _a, _b;
                    try {
                        const message = JSON.parse(event.data);
                        if (message.type === 'ping') {
                            return;
                        }
                        if (message.type === 'welcome') {
                            return resolve(ws);
                        }
                        if (message.message) {
                            (_b = (_a = channelsRef.current)[message.identifier]) === null || _b === void 0 ? void 0 : _b.call(_a, message.message);
                        }
                    }
                    catch (error) {
                        logError(error);
                    }
                };
                ws.onclose = () => {
                    setTimeout(() => setWebSocket(undefined), 10000);
                };
                ws.onerror = () => {
                    setTimeout(() => setWebSocket(undefined), 10000);
                };
            });
            setWebSocket(newWebSocket);
        }))();
    }, [currentProfileGid, logError, webSocketUrl, webSocket]);
    return (react_1.default.createElement(WebSocketContext_1.webSocketContext.Provider, { value: currentProfileGid && webSocket
            ? { currentProfileGid, registerForChannel, sendCommand }
            : undefined }, children));
};
exports.WebSocketProvider = WebSocketProvider;
